import { useState } from 'react';
import { Home, Message, BarChart, Person, Add, Inbox, Notifications, TrendingUp, People, Settings, Language, Menu, ChevronLeft } from '@mui/icons-material';
import neostatsText from './NeoStats-White Text.png'
import logoIcon from './NeoStats N Logo.png'

const Sidebar = ({ onViewChange }) => {
  const [activeItem, setActiveItem] = useState('Home');
  const [collapsed, setCollapsed] = useState(false);
  
  const menuItems = [
    { title: 'Home', icon: <Home />, view: 'dashboard', clickable: true },
    { title: 'Analytics Dashboard', icon: <BarChart />, view: 'analytics', clickable: true },
    { title: 'RM360', icon: <Message />, view: 'RM360', clickable: true },
    { title: 'Customer Overview', icon: <Person />, view: 'customer-overview', clickable: true },
  ];  

  const handleMenuClick = (title, view) => {
    if (title === 'Logout') {
      console.log('Logging out...');
      return;
    }
    setActiveItem(title);
    if (onViewChange) {
      console.log('Changing view to:', view);
      onViewChange(view);
    }
  };

  const handleQuickActionClick = (action) => {
    setActiveItem(action);
    if (onViewChange) {
      console.log('Changing view to:', action);
      onViewChange(action);
    }
  };

  const handleAnalyticsClick = (analytics) => {
    setActiveItem(analytics);
    if (onViewChange) {
      console.log('Changing view to:', analytics);
      onViewChange(analytics);
    }
  };

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className={`${collapsed ? 'w-16' : 'w-64'} bg-[#1A1A1A] border-r border-[#2A2A2A] h-full transition-all duration-300 flex flex-col shadow-xl`}>
      {/* Mukuru Logo Section */}
      <div className={`${collapsed ? 'p-3' : 'px-4 py-4'} border-b border-[#2A2A2A] flex items-center min-h-[72px]`}>
        <div className="flex items-center space-x-3 w-full">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center">
            <img src="/NeoStats_N_Logo.png" alt="MUKURU" width={32} height={32} className="animate-spin" style={{animationDuration: '3s'}} />
          </div>
          {!collapsed && (
            <div className="flex-1">
              <div className="text-sm font-semibold text-[#FFFFFF]">NeoStats</div>
              <div className="text-xs text-[#B0B0B0]">Financial Services</div>
            </div>
          )}
        </div>
      </div>
      
      {/* Navigation Menu */}
      <nav className="mt-4 flex-1 px-3">
        {/* Main Navigation */}
        <div className="mb-6">
          {!collapsed && (
            <div className="text-xs font-semibold text-[#808080] uppercase tracking-wider mb-3">
              Navigation
            </div>
          )}
          {menuItems.map((item, index) => (
            <div
              key={index}
              onClick={() => item.clickable && handleMenuClick(item.title, item.view)}
              className={`${collapsed ? 'justify-center px-2' : 'px-3'} py-3 flex items-center cursor-pointer transition-all duration-200 rounded-xl mb-1
                ${activeItem === item.title 
                  ? 'bg-[#B4E50D] text-[#0A0A0A] shadow-lg' 
                  : 'text-[#B0B0B0] hover:bg-[#2A2A2A] hover:text-[#FFFFFF]'
                }
                ${item.clickable ? 'cursor-pointer' : 'cursor-default'}
                group
              `}
              title={collapsed ? item.title : ''}
            >
              {item.icon && (
                <span className={`${collapsed ? 'text-[#B4E50D]' : 'mr-3 text-[#B4E50D]'} ${activeItem === item.title ? 'text-[#0A0A0A]' : ''}`}>
                  {item.icon}
                </span>
              )}
              {!collapsed && (
                <span className={`font-medium ${activeItem === item.title ? 'text-[#0A0A0A]' : 'text-[#B0B0B0]'}`}>
                  {item.title}
                </span>
              )}
            </div>
          ))}
        </div>

        {/* Quick Actions */}
        <div className="mb-6">
          {!collapsed && (
            <div className="text-xs font-semibold text-[#808080] uppercase tracking-wider mb-3">
              Quick Actions
            </div>
          )}
          <div className={`${collapsed ? 'space-y-3' : 'space-y-2'}`}>
            <div 
              onClick={() => handleQuickActionClick('inbox')}
              className={`${collapsed ? 'justify-center px-2' : 'px-3'} py-2 flex items-center text-[#B0B0B0] hover:bg-[#2A2A2A] hover:text-[#FFFFFF] rounded-lg cursor-pointer transition-colors ${
                activeItem === 'inbox' ? 'bg-[#2A2A2A] text-[#FFFFFF]' : ''
              }`}
              title={collapsed ? 'Inbox' : ''}
            >
              <Inbox className={`${collapsed ? 'text-[#B4E50D]' : 'text-[#B4E50D] mr-3'} text-sm`} />
              {!collapsed && <span className="text-sm">Inbox</span>}
            </div>
            <div 
              onClick={() => handleQuickActionClick('alerts')}
              className={`${collapsed ? 'justify-center px-2' : 'px-3'} py-2 flex items-center text-[#B0B0B0] hover:bg-[#2A2A2A] hover:text-[#FFFFFF] rounded-lg cursor-pointer transition-colors ${
                activeItem === 'alerts' ? 'bg-[#2A2A2A] text-[#FFFFFF]' : ''
              }`}
              title={collapsed ? 'Alerts' : ''}
            >
              <Notifications className={`${collapsed ? 'text-[#B4E50D]' : 'text-[#B4E50D] mr-3'} text-sm`} />
              {!collapsed && (
                <>
                  <span className="text-sm">Alerts</span>
                  <span className="ml-auto bg-[#FF6B6B] text-[#FFFFFF] text-xs px-2 py-1 rounded-full">2</span>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Analytics Section */}
        <div className="mb-6">
          {!collapsed && (
            <div className="text-xs font-semibold text-[#808080] uppercase tracking-wider mb-3">
              Analytics
            </div>
          )}
          <div className={`${collapsed ? 'space-y-3' : 'space-y-2'}`}>
            <div 
              onClick={() => handleAnalyticsClick('subscribers')}
              className={`${collapsed ? 'justify-center px-2' : 'px-3'} py-2 flex items-center text-[#B0B0B0] hover:bg-[#2A2A2A] hover:text-[#FFFFFF] rounded-lg cursor-pointer transition-colors ${
                activeItem === 'subscribers' ? 'bg-[#2A2A2A] text-[#FFFFFF]' : ''
              }`}
              title={collapsed ? 'Subscribers' : ''}
            >
              <People className={`${collapsed ? 'text-[#B4E50D]' : 'text-[#B4E50D] mr-3'} text-sm`} />
              {!collapsed && (
                <>
                  <span className="text-sm">Subscribers</span>
                  <span className="ml-auto bg-[#FF6B6B] text-[#FFFFFF] text-xs px-2 py-1 rounded-full">34</span>
                </>
              )}
            </div>
            <div 
              onClick={() => handleAnalyticsClick('reports')}
              className={`${collapsed ? 'justify-center px-2' : 'px-3'} py-2 flex items-center text-[#B0B0B0] hover:bg-[#2A2A2A] hover:text-[#FFFFFF] rounded-lg cursor-pointer transition-colors ${
                activeItem === 'reports' ? 'bg-[#2A2A2A] text-[#FFFFFF]' : ''
              }`}
              title={collapsed ? 'Reports' : ''}
            >
              <BarChart className={`${collapsed ? 'text-[#B4E50D]' : 'text-[#B4E50D] mr-3'} text-sm`} />
              {!collapsed && <span className="text-sm">Reports</span>}
            </div>
          </div>
        </div>
      </nav>
      
      {/* Bottom Section */}
      <div className={`${collapsed ? 'p-3' : 'p-4'} border-t border-[#2A2A2A]`}>
        {!collapsed ? (
          <div className="flex items-center space-x-3 text-[#B0B0B0]">
            <img src={logoIcon} alt="NeoStats N" className="w-8 h-8 object-contain" />
                          <div className="flex-1">
                <div className="text-sm font-medium text-[#FFFFFF]">RM360</div>
                <div className="flex items-center text-xs text-[#808080] mt-1">
                  <span>Powered by&nbsp;</span>
                  <img src={neostatsText} alt="Powered by NeoStats" className="h-4 opacity-80" />
                </div>
              </div>
          </div>
        ) : (
          <div className="flex justify-center">
            <img src={logoIcon} alt="NeoStats N" className="w-8 h-8 object-contain" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;